import React from 'react';
import { Button, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import _ from 'lodash';

// Services
import CollaboratoreService from 'shared/services/rpc/gestione-collaboratore';

const FiltersContainer = styled.div`
  background: #efefef;
  border: 1px solid #ccc;
  border-radius: 3;
  padding: 11px;
  padding-bottom: 22px;
  display: flex;
  justify-content: space-between;
  align-items: self-end;

  .dropdown-container {
    width: 100%;
    max-width: 450px;

    span {
      font-weight: bolder;
      padding-left: 2px;
    }
  }

  .buttons-collection {
    display: flex;
    width: 150px;
  }
`;

export class ResponsabileAreaFilterBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      responsabiliAreaOptions: [],
      responsabiliAreaLoading: false,
    };
  }

  componentDidMount() {
    this.getResponsabiliArea();
  }

  getResponsabiliArea = () => {
    this.setState({ responsabiliAreaLoading: true });

    CollaboratoreService.getResponsabiliByAgenzia(null)
      .then((res) => {
        let options = [];

        if (
          _.get(this.props.auth, 'roles.list', null) &&
          this.props.auth.roles.list.includes('responsabile area') &&
          _.get(this.props.auth, 'ACL.list[0]', null)
        ) {
          const respArea = res.listaResponsabiliArea.find((option) => option.username === this.props.auth.ACL.list[0]);

          if (!_.isEmpty(respArea)) {
            options.push({
              key: respArea.id,
              value: respArea.id,
              text: respArea.nominativo,
            });
          }
        } else if (_.get(this.props.auth, 'profiles.list')) {
          // If logged user has profile get only its RA
          this.props.auth.profiles.list.forEach((profile) => {
            const respArea = res.listaResponsabiliArea.find((option) => option.username === profile.responsabileArea);

            if (!_.isEmpty(respArea)) {
              options.push({
                key: respArea.id,
                value: respArea.id,
                text: respArea.nominativo,
              });
            }
          });
        } else {
          // Otheriwse get all list
          options = res.listaResponsabiliArea.map((option) => ({
            key: option.id,
            value: option.id,
            text: option.nominativo,
          }));
          options = [{ key: '-', value: null, text: '--' }].concat(options);
        }

        // Update state
        if (options.length === 1) {
          this.setState({
            responsabiliAreaOptions: options,
            responsabiliAreaLoading: false,
          });
          this.props.onChangeResposabileArea(options[0].key);
        } else {
          const orderedRaArray = _.orderBy(options, ['text']);
          this.setState({ responsabiliAreaOptions: orderedRaArray, responsabiliAreaLoading: false });
          this.props.onChangeResposabileArea('');
        }
      })
      .catch(() => this.setState({ responsabiliAreaLoading: false }));
  };

  render() {
    return (
      <FiltersContainer>
        <div className="dropdown-container">
          <span>Responsabile Area</span>
          <Dropdown
            fluid
            label="Responsabile Area"
            loading={this.state.responsabiliAreaLoading}
            options={this.state.responsabiliAreaOptions}
            placeholder="- - -"
            search
            selection
            value={this.props.selectedResponsabileArea}
            onChange={(_e, { value }) => this.props.onChangeResposabileArea(value)}
          />
        </div>
        <div className="buttons-collection">
          <Button
            icon="remove"
            labelPosition="left"
            content="Reset"
            fluid
            onClick={() => this.props.onReset(this.state.responsabiliAreaOptions[0].value)}
            disabled={this.state.responsabiliAreaLoading}
          />
        </div>
      </FiltersContainer>
    );
  }
}

ResponsabileAreaFilterBar.propTypes = {
  auth: PropTypes.object,
  onChangeResposabileArea: PropTypes.func,
  onReset: PropTypes.func,
  selectedResponsabileArea: PropTypes.string,
};

export default ResponsabileAreaFilterBar;



// WEBPACK FOOTER //
// ./app/components/NetworkDashboard/ResponsabileAreaFilterBar/index.js